import React, { useEffect, useRef, useState } from 'react';
import { Home, Sparkles, TruckIcon, Building2, HardHat, Droplets } from 'lucide-react';
import './Services.css';

const servicesData = [
  {
    icon: Home,
    title: 'Residential Cleaning',
    description: 'Complete home cleaning services to keep your living space spotless and comfortable.',
    image: 'https://images.unsplash.com/photo-1686178827149-6d55c72d81df?w=600&h=400&fit=crop'
  },
  {
    icon: Sparkles,
    title: 'Deep Cleaning',
    description: 'Thorough and intensive cleaning for every corner, removing dirt and grime from hard-to-reach areas.',
    image: 'https://images.unsplash.com/photo-1742483359033-13315b247c74?w=600&h=400&fit=crop'
  },
  {
    icon: TruckIcon,
    title: 'Move-in / Move-out Cleaning',
    description: 'Comprehensive cleaning services to prepare your new space or leave your old one pristine.',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=400&fit=crop'
  },
  {
    icon: Building2,
    title: 'Office & Commercial Cleaning',
    description: 'Professional cleaning solutions for offices, retail spaces, and commercial properties.',
    image: 'https://images.unsplash.com/photo-1627905646269-7f034dcc5738?w=600&h=400&fit=crop'
  },
  {
    icon: HardHat,
    title: 'Post-construction Cleaning',
    description: 'Specialized cleaning after construction or renovation to remove debris and dust.',
    image: 'https://images.unsplash.com/photo-1647381518264-97ff1835026f?w=600&h=400&fit=crop'
  },
  {
    icon: Droplets,
    title: 'Eco-Friendly Cleaning',
    description: 'Green cleaning solutions using environmentally safe products for a healthier space.',
    image: 'https://images.pexels.com/photos/4239035/pexels-photo-4239035.jpeg?w=600&h=400&fit=crop'
  }
];

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="services" ref={sectionRef} className="services-section">
      <div className="services-container">
        <div className={`services-content ${isVisible ? 'visible' : ''}`}>
          <div className="section-header">
            <span className="section-badge">Our Services</span>
            <h2 className="section-title">Complete Cleaning Solutions</h2>
            <p className="section-subtitle">
              Professional cleaning services tailored to meet your specific needs
            </p>
          </div>
          <div className="services-grid">
            {servicesData.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <div 
                  key={index} 
                  className="service-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="service-image"
                    />
                    <div className="service-image-overlay">
                      <IconComponent className="service-icon-large" size={48} />
                    </div>
                  </div>
                  <div className="service-content">
                    <div className="service-icon-wrapper">
                      <IconComponent className="service-icon" size={28} />
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
